import { LogoContainer } from "./styles";

export default function Logo({ size, logoSrc, top = 0, left = 0 }) {
  return (
    <LogoContainer
      size={size}
      hasLogo={Boolean(logoSrc)}
      top={top}
      left={left}
    >
      {logoSrc && <img src={logoSrc} alt="logo" />}
      {!logoSrc && <span>Logo</span>}
    </LogoContainer>
  );
}
